/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Delete_ConfirmInputs */

const en_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, delete`)
};

const fr_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, supprimer`)
};

const de_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, löschen`)
};

const it_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, elimina`)
};

const ru_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, удалить`)
};

const es_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, eliminar`)
};

const zh_cn2_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，删除`)
};

const ja_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、削除します`)
};

const hi_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, हटा दें`)
};

const pt_pt2_context_menu_delete_confirm = /** @type {(inputs: Context_Menu_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, apagar`)
};

/**
* | output |
* | --- |
* | "Yes, delete" |
*
* @param {Context_Menu_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_delete_confirm = /** @type {((inputs?: Context_Menu_Delete_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Delete_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_delete_confirm(inputs)
	if (locale === "de") return de_context_menu_delete_confirm(inputs)
	if (locale === "it") return it_context_menu_delete_confirm(inputs)
	if (locale === "ru") return ru_context_menu_delete_confirm(inputs)
	if (locale === "es") return es_context_menu_delete_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_delete_confirm(inputs)
	if (locale === "ja") return ja_context_menu_delete_confirm(inputs)
	if (locale === "hi") return hi_context_menu_delete_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_delete_confirm(inputs)
	return en_context_menu_delete_confirm(inputs)
});